import {
  StyleSheet,
  View,
  TouchableOpacity,
  ActivityIndicator,
} from "react-native";
import React from "react";
import color from "@constants/color";
import t from "@constants/localization";
import CloseIcon from "@assets/svg/CloseIcon";
import CustomText from "@components/CustomText";
import { DeliveryAction } from "./RTOModal";

const PATH = "components/InAppRTOModal";

const NeededButton = ({
  onPressNeeded = () => {},
  checkNeededLoading = false,
  checkNotNeededLoading = false,
  containerStyle = {},
  submitButtons = {},
}) => {
  const {
    yes = {
      text: t(`${PATH}/needed`),
      reasons: "",
    },
    no = {
      text: t(`${PATH}/notNeeded`),
      reasons: "",
    },
  } = submitButtons || {};
  return (
    <View style={[styles.container, containerStyle]}>
      <TouchableOpacity
        onPress={() => onPressNeeded(DeliveryAction.NO, no?.reasons || "")}
        disabled={checkNotNeededLoading}
        style={styles.notNeededContainer}
      >
        {checkNotNeededLoading ? (
          <View style={styles.buttonLoader}>
            <ActivityIndicator size="small" color={color.mediumBlack} />
          </View>
        ) : (
          <React.Fragment>
            <CloseIcon />
            <CustomText
              variant="subtitle_16"
              newfont={true}
              style={styles.notNeeded}
            >
              {no.text}
            </CustomText>
          </React.Fragment>
        )}
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => onPressNeeded(DeliveryAction.YES, yes?.reasons || "")}
        disabled={checkNeededLoading}
        style={styles.neededContainer}
      >
        {checkNeededLoading ? (
          <View style={styles.buttonLoader}>
            <ActivityIndicator size="small" color={color.white} />
          </View>
        ) : (
          <React.Fragment>
            <AcceptIcon />
            <CustomText
              variant="subtitle_16"
              newfont={true}
              style={styles.needed}
              numberOfLines={1}
            >
              {yes?.text}
            </CustomText>
          </React.Fragment>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default NeededButton;

const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  notNeededContainer: {
    width: "45%",
    height: 40,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: color.white,
    borderRadius: 8,
    borderColor: "rgba(0, 0, 0, 0.2)",
    borderWidth: 1,
    flexDirection: "row",
  },
  notNeeded: {
    color: color.mediumBlack,
    marginStart: 10,
  },
  neededContainer: {
    width: "45%",
    height: 40,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: color.plain_green,
    borderRadius: 8,
    flexDirection: "row",
  },
  needed: {
    color: color.white,
    marginStart: 10,
  },
  buttonLoader: {
    position: "absolute",
    alignSelf: "center",
  },
});
